<template>
  <div
    class="layer-area plp-v2 plp-v2-st2 address_change"
    :class="classDisplayPopup"
  >
    <div class="layer-area_container with_pop_head shipping_delivery_st02">
      <div class="layer-prd_search_top cash_tax">
        <div class="pop_head">
          <span
            ><button class="btn_back"><em class="sp_ic">이전</em></button></span
          >
          <h2 class="tax">배송지 선택</h2>
        </div>
      </div>

      <div class="layer-area_content2">
        <div class="address_mobile">
          <div class="tab-body new-payment gift_order renew">
            <div class="tab-content tab-pane">
              <div class="pop_head_sotit">
                <div class="address_btn-group">
                  <button
                    type="button"
                    class="address_search"
                    @click="toggleSearch = !toggleSearch"
                    :class="classToggleSearch"
                  >
                    배송지 검색
                  </button>
                </div>
                <div
                  class="address_search_inbox collapse"
                  :class="toggleSearch ? 'in' : ''"
                  :aria-expanded="toggleSearch"
                >
                  <div class="address_search_inbox_inner">
                    <div class="applicants-panel-in">
                      <div class="input-group">
                        <input
                          type="text"
                          title="검색어 입력"
                          placeholder="주소, 받는 분 입력"
                          v-model="searchKeyword"
                          @keyup.enter="searchAddress"
                        />
                        <button
                          class="btn btn-link"
                          type="button"
                          @click="searchAddress"
                        >
                          검색
                        </button>
                      </div>
                    </div>
                    <button class="search-results-close" @click="cancelSearch">
                      검색취소
                    </button>
                  </div>
                </div>
              </div>

              <!-- 배송지 유닛-->
              <address-unit
                v-for="addr in indexedAddresses"
                :key="addr.index"
                :address="addr"
                :stored-delivery-info="storedDeliveryInfo"
                @toggle-address-radio="toggleRadioChecked"
                @update-delivery-message="updateDeliveryMessage"
                @direct-input-message="directInputMessage"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="layer-area_bottom01">
        <div class="align-box size-auto">
          <button type="button" class="btn-modal_close v2" @click="closeModal">
            취소
          </button>
          <button type="button" class="btn-modal_apply" @click="onClickSelect">
            선택
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AddressUnit from "@/views/order/main/components/DeliveryPopUpContents/AddressUnit";
import orderApi from "@/apis/order";
import { mapGetters } from "vuex";

export default {
  name: "PopupDeliveryAddresses",
  components: {
    AddressUnit,
  },
  created() {
    this.init();
  },
  methods: {
    toggleRadioChecked(event) {
      this.indexedAddresses = this.indexedAddresses.map((addr) => {
        addr.checked = addr.index === event;
        return addr;
      });

      // 검색시 라디오 박스 체크 오류 때문에 추가
      this.cachedIndexedAddress = this.cachedIndexedAddress.map((addr) => {
        addr.checked = addr.index === event;
        return addr;
      });

      this.selectedAddress = this.indexedAddresses.find(
        (addr) => addr.index === event
      );
      this.deliveryMessage = {
        code: "CPN",
        text: "배송메시지를 선택해 주세요",
      };
    },
    closeModal(event) {
      this.$emit("close-modal", true);
      this.indexedAddresses = [...this.cachedIndexedAddress];
    },
    async init() {
      let result = [];
      if (this.deliveryList.length > 0) {
        result = this.deliveryList;
      } else {
        result = await orderApi.getDeliveryList();
      }
      if (result.error) {
        return;
      }
      this.indexedAddresses = result.map((addr, index) => {
        return {
          ...addr,
          index: index,
          checked: addr.id === this.selectedDeliveryAddress.id,
          message: addr.id === this.selectedDeliveryAddress.id ? this.selectedDeliveryAddress.message : "", 
        };
      });
      this.cachedIndexedAddress = [...this.indexedAddresses];
      this.selectedAddress = this.indexedAddresses[0];
    },
    updateDeliveryMessage(event) {
      this.deliveryMessage = event;
    },
    directInputMessage(event) {
      this.deliveryMessage.text = event;
    },
    onClickSelect() {
      if (this.selectedAddress === {}) {
        alert("배송지가 선택되지 않았습니다.");
        return false;
      }

      if (this.deliveryMessage.code === "CPN") {
        this.deliveryMessage.text = "";
      }

      let deliveryInfo = {
        id: this.selectedAddress.id,
        cellphone:
          this.selectedAddress.mobileArea + this.selectedAddress.mobileNumber,
        formattedAddress: this.selectedAddress.defaultAddress.formattedAddress,
        name: this.selectedAddress.name,
        postalCode: this.selectedAddress.defaultAddress.postalCode,
        message: this.deliveryMessage.text,
      };

      this.$emit("select-delivery-address", deliveryInfo);
      this.$emit("close-modal", true);
    },
    cancelSearch() {
      this.toggleSearch = false;
      this.indexedAddresses = [...this.cachedIndexedAddress];
    },
    searchAddress() {
      this.indexedAddresses = this.cachedIndexedAddress.filter(
        (addr) =>
          addr.name.includes(this.searchKeyword) ||
          addr.defaultAddress.formattedAddress.includes(this.searchKeyword)
      );
    },
  },
  data() {
    return {
      selectedAddress: {},
      indexedAddresses: [],
      cachedIndexedAddress: [],
      searchKeyword: "",
      deliveryMessage: {
        code: "CPN",
        text: "배송메시지를 선택해 주세요",
      },
      toggleSearch: false,
    };
  },
  computed: {
    classDisplayPopup() {
      return this.displayModal ? "showing" : "";
    },
    classToggleSearch() {
      return this.toggleSearch ? "" : "collapsed";
    },
    ...mapGetters({
      storedDeliveryInfo: "delivery/deliveryInfo",
    }),
  },
  props: {
    displayModal: {
      type: Boolean,
      default: false,
    },
    deliveryList: {
      type: Array,
      default: () => [],
    },
    selectedDeliveryAddress: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style scoped>
</style>
